import { Component } from 'react';
import './Portfolio.css';

class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [
        {
          project_image: "",
          title: "E-commerce Website",
          description: "A full-stack e-commerce platform built with React and Node.js",
          technologies: ["React", "Node.js", "MongoDB", "CSS3"],
        },
        {
          project_image: "",
          title: "Task Management App",
          description: "A collaborative task management application with real-time updates",
          technologies: ["React", "Socket.io", "Express", "PostgreSQL"],
        },
      ]
    };
  }

  render() {
    return (
      <div className="portfolio-section">
        <h2 className="portfolio-title">My Portfolio</h2>

        <div className="projects-container"> 
          {this.state.projects.map((project) => (
            <div className="project-card" key={project.title}>
              <div className="project-image-placeholder">Project Image</div>

              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>

              <div className="tech-list">
                {project.technologies.map((tech) => (
                  <span className="tech-pill" key={tech}>{tech}</span>
                ))}
              </div>

              <div className="project-buttons">
                <button>Live Demo</button>
                <button>View Code</button>
              </div>
            </div>
          ))}
          </div>
      </div>
    );
  }
}

export default Portfolio;